module.exports = __webpack_public_path__ + "static/media/bellabyte-brinde-caneta-personalizado-768x591.0fd274eb.jpg";